import { Divider, type DividerProps } from 'antd'

import cn from '@/utils/tailwind/cn'

export const SectionDivider = ({ className, ...props }: DividerProps) => (
  <Divider className={cn('my-0', className)} {...props} />
)
